enum CurrentHoldEventType {
	NONE,
	UPDATE,
	ADD,
}

export default CurrentHoldEventType;
